import {TableRowProps} from 'notebook/tables/core-ui/TableRow';

export function isRowSelected(props: TableRowProps): boolean {
  return props.selectedMinJ != null && props.selectedMaxJ != null;
}
